function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "129",
  height: "115",
  viewBox: "0 0 129 115",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.778 4.621c-.749-3.25-4.065-5.176-7.286-4.312L5.769 29.747c-3.157.847-5.037 4.064-4.434 7.277a102.901 102.901 0 011.758 18.979c0 7.455-.8 14.733-2.318 21.75-.707 3.269 1.18 6.601 4.412 7.46l109.684 29.16c3.19.848 6.475-1.038 7.256-4.246 4.227-17.359 6.468-35.487 6.468-54.126 0-17.658-2.011-34.858-5.817-51.38z",
  fill: "#fff"
})));